import React, { useState } from 'react';
import axios from 'axios';
import { showError } from '../utils/alerts';
import { API_BASE_URL } from '../config';
import FechaSelector from '../components/FechaSelector';
import TablaBalance from '../components/TablaBalance';
import '../styles/pages/VerBalance.css';


const VerBalance = ({ token, id_company }) => {
  const [mes, setMes] = useState('');
  const [anual, setAnual] = useState('');
  const [balanceData, setBalanceData] = useState([]);
  const handleDateChange = (selectedMes, selectedAnual) => {
    setMes(selectedMes);
    setAnual(selectedAnual);
  };
  const isMonthClosed = async (mes, anio, company, token) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/cierre-mensual`, {
        params: { company, anio },
        headers: { Authorization: `Bearer ${token}` }
      });
      const monthData = res.data.find(
        (item) => item.mes === parseInt(mes, 10)
      );
      return monthData ? monthData.cerrado : false;
    } catch (error) {
      console.error('Error al verificar cierre mensual:', error);
      return false;
    }
  };
  const handleBuscarBalance = async () => {
    if (!mes || !anual) {
      showError('Por favor selecciona un mes y un año');
      return;
    }

    console.log(`Buscando balance para mes: ${mes}, año: ${anual}`);

    // Verificar que el mes esté cerrado
    const cerrado = await isMonthClosed(mes, anual, id_company, token);
    if (!cerrado) {
      showError('El mes seleccionado no está cerrado. Debes cerrar el mes primero para ver el balance.');
      return;
    }

    try {
      // Si el mes está cerrado, el balance ya debe existir (generado al cerrar)
      const response = await axios.get(`${API_BASE_URL}/api/buscar-balance`, {
        params: { mes, anual, id_company },
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data && response.data.length > 0) {
        setBalanceData(response.data);
      } else {
        // Esto no debería suceder si el mes está cerrado correctamente
        showError('No se encontró el balance. Por favor, contacta al administrador.');
      }
    } catch (error) {
      console.error('Error al buscar balance:', error);
      const message = error.response?.data || 'Error al buscar balance';
      showError(message);
    }
  };

  return (
    <div>
      <h1>Ver Balance General</h1>
      <FechaSelector onDateChange={handleDateChange} />
      <button onClick={handleBuscarBalance}>Ver Balance General</button>
      <TablaBalance data={balanceData} />
    </div>
  );
};

export default VerBalance;
